<mat-form-field>
  <mat-label>Recipients</mat-label>

  <mat-chip-grid #chipGrid aria-label="Recipients">
    <mat-chip-row *ngFor="let user of selectedUsers" (removed)="remove(user)">
      {{ user.name }}
      <button matChipRemove [attr.aria-label]="'Remove ' + user.name">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input
      placeholder="Add recipient"
      #userInput
      [formControl]="addUserControl"
      [matAutocomplete]="userAutocomplete"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    />
  </mat-chip-grid>

  <mat-autocomplete
    autoActiveFirstOption
    #userAutocomplete="matAutocomplete"
    (optionSelected)="selected($event)"
  >
    <mat-option *ngFor="let user of searchUsers" [value]="user">
      <span>{{ user.name }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
